import { useEffect } from "react";
import { Overline } from "@/components/Reveal";

const content = {
  privacy: {
    overline: "Legal",
    title: "Privacy Policy",
    updated: "Last updated: 2026",
    sections: [
      {
        h: "Information We Collect",
        p: "When you contact ADD VALUE HOLDINGS LLC through this website, we collect the information you provide directly — your name, email address, phone number, company name, and the content of your message. If you join the ADD VALUE Clothing waitlist, we collect your email address.",
      },
      {
        h: "How We Use It",
        p: "Information submitted through this site is used solely to respond to your inquiry and, for waitlist signups, to notify you about product releases. We do not sell, rent, or share your personal information with third parties for their marketing purposes.",
      },
      {
        h: "Data Retention",
        p: "Inquiry and waitlist records are retained for as long as needed to manage our relationship with you, after which they may be deleted. You may request removal of your information at any time by contacting us.",
      },
      {
        h: "Contact",
        p: "Questions about this policy can be sent through the contact page of this website.",
      },
    ],
  },
  terms: {
    overline: "Legal",
    title: "Terms of Use",
    updated: "Last updated: 2026",
    sections: [
      {
        h: "Acceptance",
        p: "By accessing this website, you agree to these terms. If you do not agree, please do not use the site.",
      },
      {
        h: "Content",
        p: "All content on this website — including text, imagery, the ADD VALUE name, and brand marks — is the property of ADD VALUE HOLDINGS LLC and may not be reproduced without written permission.",
      },
      {
        h: "No Offer or Advice",
        p: "Content on this site is provided for general information only. Nothing on this site constitutes an offer, solicitation, investment advice, or a commitment of any kind.",
      },
      {
        h: "Changes",
        p: "These terms may be updated from time to time. Continued use of the site after changes constitutes acceptance of the updated terms.",
      },
    ],
  },
};

const Legal = ({ kind }) => {
  const c = content[kind];

  useEffect(() => {
    document.title = `${c.title} — ADD VALUE HOLDINGS LLC`;
  }, [c.title]);

  return (
    <div data-testid={`legal-${kind}-page`} className="mx-auto min-h-screen max-w-4xl px-6 pb-24 pt-40 sm:px-8">
      <Overline>{c.overline}</Overline>
      <h1 className="mt-6 font-serif text-3xl tracking-tight text-white sm:text-4xl">
        {c.title}
      </h1>
      <p className="mt-4 font-mono text-[10px] uppercase tracking-[0.3em] text-stone-600">
        {c.updated}
      </p>
      <div className="mt-14 space-y-12">
        {c.sections.map((s) => (
          <section key={s.h} className="border-t border-[#222226] pt-8">
            <h2 className="font-serif text-xl text-white">{s.h}</h2>
            <p className="mt-4 text-sm font-light leading-relaxed text-stone-400">
              {s.p}
            </p>
          </section>
        ))}
      </div>
    </div>
  );
};

export default Legal;
